import { JOKI } from "../../../JOKI";
import { warning, notice } from "../../Notifications/notice";

//TODO: Make this websocket also work with endpoints.
export function connectVpn(device, params) {
    // console.log("VpnCommands:connectVpn", device);
    const { selectedOption } = params;

    if (typeof device.code !== "string") {
        warning(`The device Code is not a string ${device.code}`);
        return;
    }
    let commandUrl = "";

    if (selectedOption && selectedOption.value === 'legacy') {
        commandUrl = `device/${device.code}/command/start_vpn`;
    } else {
        commandUrl = `device/${device.code}/v2/command/start_vpn/${selectedOption.value}`
    }

    JOKI.ask({
        to: "SocketIoService",
        key: "emitEvent",
        body: {
            url: commandUrl,
        },
    }).then(() => {

        notice(`VPN Connection to ${device.name} opened successfully.`);
    }).catch(() => {

        warning(`VPN Connection to ${device.name} opening closed.`);
    });

    // function(dispatch) {
    //     dispatch(showLoading());
    //     // connect to MQTT and send the command
    //     const client = io(process.env.REACT_APP_SOCKETIO_SERVER_URL);
    //     client.on('connect', () => {
    //         console.log(
    //             'Connected to ',
    //             process.env.REACT_APP_SOCKETIO_SERVER_URL
    //         );
    //         console.log(`device/${cabinet.code}/command/start_vpn`);
    //         client.emit(`device/${cabinet.code}/command/start_vpn`, 'do'); // payload is optional
    //         client.close();
    //         // hide loading bar
    //         dispatch(hideLoading());
    //         // notify success
    //         // Notify(i18n.t('messages:VPN connect command sent'));
    //     });
    //     client.on('error', () => {
    //         // hide loading bar
    //         dispatch(hideLoading());
    //         // notify failure
    //         console.log('reboot command sent error');
    //         // Notify(i18n.t('messages:Error', cabinet.code), 'error');
    //     });
    // };
}

export function disconnectVpn(device, params) {
    // console.log("VpnCommands:disconnectVpn", device);


    if (typeof device.code !== "string") {
        warning(`The device Code is not a string ${device.code}`);
        return;
    }
    JOKI.ask({
        to: "SocketIoService",
        key: "emitEvent",
        body: {
            url: `device/${device.code}/command/stop_vpn`,
        },
    }).then(() => {

        notice(`VPN Connection to ${device.name} closed successfully.`);
    }).catch(() => {

        warning(`Closing VPN Connection to ${device.name} FAILED.`);
    });;

    // function(dispatch) {
    //     dispatch(showLoading());
    //     // connect to MQTT and send the command
    //     const client = io(process.env.REACT_APP_SOCKETIO_SERVER_URL);
    //     client.on('connect', () => {
    //         console.log(
    //             'Connected to ',
    //             process.env.REACT_APP_SOCKETIO_SERVER_URL
    //         );
    //         console.log(`device/${cabinet.code}/command/stop_vpn`);
    //         client.emit(`device/${cabinet.code}/command/stop_vpn`, 'do'); // payload is optional
    //         client.close();
    //         // hide loading bar
    //         dispatch(hideLoading());
    //         // notify success
    //         // Notify(i18n.t('messages:VPN disconnect command sent'));
    //     });
    //     client.on('error', () => {
    //         // hide loading bar
    //         dispatch(hideLoading());
    //         // notify failure
    //         console.log('reboot command sent error');
    //         // Notify(i18n.t('messages:Error', cabinet.code), 'error');
    //     });
    // };
}
